import { render, staticRenderFns } from "./NormalSearchNav473.vue?vue&type=template&id=bc33852c&scoped=true"
import script from "./NormalSearchNav473.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav473.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc33852c",
  null
  
)

export default component.exports